/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import PropTypes from 'prop-types';

import './Row.scss';

const Row: FunctionComponent<{ children: React.ReactNode }> = ({ children }): JSX.Element => {
    return <div className="row">{children}</div>;
};

Row.propTypes = {
    children: PropTypes.node,
};
export default React.memo(Row);
